import React from "react"
import classNames from "classnames"

const Content = ({ classes, children }) => (
  <div className={classNames(["content", ...classes])}>{children}</div>
)

export default Content
